module.exports = __webpack_public_path__ + "static/media/hospitals.a3a0a381.svg";